<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      @click="onClickHandler"
      id="sectionId"
      class="d-flex body-content round-table-page"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >
      <div class="container-fluid">
        <div class="row new-addendee-list bg-transparent">
          <div id="headerText" class="col-md-6">
            <h1 id="headerLabel" class="page-head text-uppercase">
              {{ $t("roundtable.title") }}
            </h1>
          </div>
          <!-- <div class="col-md-8">
            <div class="right-side-hld d-flex align-items-center justify-content-end">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">You're viewing</label>
                  <select v-on:change="onChange($event)">
                    <option
                      v-for="topics in roundtableTopicData"
                      v-bind:key="topics.id"
                      :value="topics.id"
                      data-tag="roundtableFilter"
                    >{{topics.TopicName}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>-->
          <div class="col-md-6">
            <div class="row justify-content-end">
              <div class="col-md-8 mb-3 mb-md-0 pr-1">
                <div v-if="ShowSearch" class="right-search-hld">
                  <div class="position-relative fixed-w full-width search-hld">
                    <form
                      id="newsletter-validate-detail"
                      action
                      method
                      class="form subscribe"
                    >
                      <!-- <input
                      id="InputSearch"
                      type="text"
                      placeholder="Type and hit Enter to Search by Table Name...  "
                      v-model="searchtext"
                      onkeydown="return (event.keyCode!=13);"
                      data-tag="attendeeSearch"
                    /> -->
                      <input
                        id="InputSearch"
                        type="text"
                        :placeholder="$t('roundtable.searchplaceholder')"
                        v-model="searchtext"
                        @keyup="searchRoundtable2"
                        v-on:keydown.enter.prevent="searchRoundtable"
                        data-tag="attendeeSearch"
                      />
                    </form>
                  </div>
                  <a
                    href="javascript:void(0);"
                    @click="searchRoundtable"
                    v-if="ShowSearch"
                    >GO</a
                  >
                </div>
              </div>

              <div v-if="ShowFilter" class="col-md-4 mb-3 mb-md-0 pl-1">
                <div class="position-relative fixed-w full-width filter-hld">
                  <select v-on:change="onChange($event)" v-model="tid">
                    <option
                      v-for="topics in roundtableTopicData"
                      v-bind:key="topics.id"
                      :value="topics.id"
                      data-tag="roundtableFilter"
                    >
                      {{ topics.TopicName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="legend">
          <ul class="p-0 m-0 d-flex align-items-center">
            <li>
              <span class="busy">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="25"
                  viewBox="0 0 34 25"
                >
                  <path
                    id="occupied.svg"
                    fill="#1a5493"
                    class="cls-1"
                    d="M833,280a3,3,0,0,1-3-3V263a2.985,2.985,0,0,1,.927-2.161A2.967,2.967,0,0,1,830,261H808a2.967,2.967,0,0,1-.927-0.161A2.985,2.985,0,0,1,808,263v14a3,3,0,0,1-6,0V263a3,3,0,0,1,3-3,2.967,2.967,0,0,1,.927.161A2.995,2.995,0,0,1,808,255h22a2.995,2.995,0,0,1,2.073,5.161A2.967,2.967,0,0,1,833,260a3,3,0,0,1,3,3v14A3,3,0,0,1,833,280Zm-5-3H810V263h18v14Z"
                    transform="translate(-802 -255)"
                  />
                </svg>
              </span>
              {{ $t("roundtable.occupied") }}
            </li>
            <li>
              <span class="free">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="25"
                  viewBox="0 0 34 25"
                >
                  <path
                    id="vacant.svg"
                    fill="#aab8c0"
                    d="M997,280a3,3,0,0,1-3-3V263a2.985,2.985,0,0,1,.927-2.161A2.967,2.967,0,0,1,994,261H972a2.967,2.967,0,0,1-.927-0.161A2.985,2.985,0,0,1,972,263v14a3,3,0,0,1-6,0V263a3,3,0,0,1,3-3,2.967,2.967,0,0,1,.927.161A2.995,2.995,0,0,1,972,255h22a2.995,2.995,0,0,1,2.073,5.161A2.967,2.967,0,0,1,997,260a3,3,0,0,1,3,3v14A3,3,0,0,1,997,280Zm-5-3H974V263h18v14Z"
                    transform="translate(-966 -255)"
                  />
                </svg>
              </span>
              {{ $t("roundtable.vacant") }}
            </li>
            <li>
              <span class="busy">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="28"
                  viewBox="0 0 34 30"
                >
                  <path
                    id="host.svg"
                    fill="#aab8c0"
                    class="cls-1"
                    d="M454,61a3,3,0,0,1-3-3V44a2.985,2.985,0,0,1,.927-2.161A2.97,2.97,0,0,1,451,42H429a2.97,2.97,0,0,1-.927-0.161A2.985,2.985,0,0,1,429,44V58a3,3,0,0,1-6,0V44a2.963,2.963,0,0,1,3.927-2.839A2.995,2.995,0,0,1,429,36h22a2.995,2.995,0,0,1,2.073,5.161A2.963,2.963,0,0,1,457,44V58A3,3,0,0,1,454,61Zm-4-28H430a4.819,4.819,0,0,0-4.828,4H424a6.839,6.839,0,0,1,7-7h18a6.838,6.838,0,0,1,7,7h-1.174A4.817,4.817,0,0,0,450,33Zm-1,25H431V44h18V58Z"
                    transform="translate(-423 -30)"
                  />
                </svg>
              </span>
              {{ roundtableSettings.HostLegend }}
            </li>
          </ul>
        </div>
        <section class="new-round-table">
          <div id="dvRoundtable" class="container-fluid clsRoundtableSpl p-0">
            <div class="row d-md-flex table-list" id="lstTables">
              <div
                v-for="roundtable in roundtableData"
                v-bind:key="roundtable.id"
                v-bind:class="
                  'col-lg-2 col-md-4 col-6 exhibitors-box-hld edit-table-btn ' +
                  roundtable.id
                "
                v-show="roundtable.IsTblVisible"
              >
                <!-- <router-link
                  v-bind:to="{ name: 'RoundtableDetails', params: { rid: roundtable.id }}"
                >-->
                <!-- <div v-if="roundtable.IsTblVisible" class="new-exhibitors-box"> -->
                <div
                  class="new-exhibitors-box"
                  v-on:click="
                    JoinTable(
                      roundtable.hostId,
                      GlobalKeysData.videoParamsEncryptURL,
                      GlobalKeysData.IsBroadcastInNewTab,
                      roundtable.id,
                      roundtable.Name,
                      '0',
                      roundtable.ChannelPrefix,
                      roundtable.BroadcastID,
                      roundtable.BroadcastCertificate,
                      roundtable.BroadcastSpeakerApiUrl,
                      roundtable.BroadcastAttendeeApiUrl,
                      roundtable.BroadcastvalidityHours,
                      roundtable.UserID,
                      eventId2,
                      roundtable.BroadcastStartURL,
                      roundtable.BroadcastViewURL,
                      roundtable.IsHost,
                      roundtable.IsMappedasAttendee,
                      roundtable.PreAssigned,
                      roundtable.SpectatorEnabled,
                      roundtable.Capacity,
                      roundtable.Occupied,
                      roundtable.IsVisible,
                      roundtable.IsTableFull,
                      GlobalKeysData.IsOpenInternalPlayer,
                      roundtable.StreamingClient,
                      roundtable.Zoom_Detail
                    )
                  "
                  data-tag="joinRoundtablevideo"
                >
                  <a>
                    <h3 data-toggle="tooltip" :title="roundtable.Name">
                      {{ roundtable.Name }}
                    </h3>
                    <div class="img-hld">
                      <img
                        v-bind:src="roundtable.imgsrc"
                        v-bind:alt="roundtable.Name"
                      />
                    </div>
                  </a>
                  <h4 v-bind:class="roundtable.LabelCss">
                    <a href="#">{{ roundtable.tableLabel }}</a>
                  </h4>
                </div>
                <!-- </router-link> -->
              </div>
            </div>
          </div>
          <div
            class="modal fade modal-container"
            id="modalOpenBroadcast"
            role="dialog"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <button
                  v-on:click="CloseModal()"
                  type="button"
                  class="close"
                  title="Close"
                  data-tag="roundtableVideoClose"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.03"
                    height="18.031"
                    viewBox="0 0 18.03 18.031"
                  >
                    <path
                      id="close.svg"
                      fill="#ffffff"
                      d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                      transform="translate(-1412 -516)"
                    />
                  </svg>
                </button>
                <div class="modal-body">
                  <iframe
                    id="iframeBroadcast"
                    src
                    height="100%"
                    width="100%"
                    allow="camera;microphone"
                  ></iframe>
                </div>
              </div>
            </div>

            <b-modal ref="my-modal" hide-footer title="Using Component Methods">
              <div class="d-block text-center"></div>
              <b-button
                class="mt-3"
                variant="outline-danger"
                block
                @click="hideModal"
                data-tag="BroadcastClise"
                >{{ $t("roundtable.closeme") }}</b-button
              >
              <b-button
                class="mt-2"
                variant="outline-warning"
                block
                @click="toggleModal"
                data-tag="BroadcastToogle"
                >{{ $t("roundtable.toggleme") }}</b-button
              >
            </b-modal>
          </div>
          <div
            id="divLoading"
            style="
              margin: 0px;
              padding: 0px;
              position: fixed;
              right: 0px;
              top: 0px;
              width: 100%;
              height: 100%;
              z-index: 30001;
              opacity: 1;
              transform: scale(2);
              display: none;
            "
          >
            <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
            <div class="loader">
              <!-- <div class="item-c item-1"></div>
        <div class="item-c item-2"></div>
        <div class="item-c item-3"></div>
              <div class="item-c item-4"></div>-->
              <svg
                width="65px"
                height="65px"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    values="0 33 33;270 33 33"
                    begin="0s"
                    dur="1.4s"
                    fill="freeze"
                    repeatCount="indefinite"
                  />
                  <circle
                    fill="none"
                    stroke-width="6"
                    stroke-linecap="round"
                    cx="33"
                    cy="33"
                    r="30"
                    stroke-dasharray="187"
                    stroke-dashoffset="610"
                  >
                    <animate
                      attributeName="stroke"
                      values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                      begin="0s"
                      dur="5.6s"
                      fill="freeze"
                      repeatCount="indefinite"
                    />
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      values="0 33 33;135 33 33;450 33 33"
                      begin="0s"
                      dur="1.4s"
                      fill="freeze"
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="stroke-dashoffset"
                      values="187;46.75;187"
                      begin="0s"
                      dur="1.4s"
                      fill="freeze"
                      repeatCount="indefinite"
                    />
                  </circle>
                </g>
              </svg>
            </div>
            <!-- </p> -->
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<style>
.right-side-hld {
  float: right;
  font-size: 21px;
  margin-top: 1.1rem;
}
.form-group label {
  font-size: 21px;
  margin-right: 1.1rem;
}
</style>

<script>
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import analytics from "@/components/Analytics";
import router from "../router";
import common from "@/common";
var self;
export default {
  components: {},
  data() {
    return {
      roundtableSettings: {
        HostLegend: "",
        SeatGrabText: this.$t("livestage.grabseat"),
        AllowAudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
      },
      headerText: this.$t("roundtable.roundtables"),
      selectedTopic: "0",
      textColor: "black",
      headerColor: "",
      searchtext: "",
      ShowFilter: false,
      ShowSearch: false,
      timerLoader: 0,
      tid: "All",
      eventcollectionname: "",
      roundtableData: [],
      SessionRTGroupIDsLoaded: false,
      SessionRTGroupIDs: [],
      expoTableIDsLoaded: false,
      expoTableIDs: [],
      eventId2: "",
      userid: "",
      clientid: "",
      roundtableTopicData: [],
      roundtableAttendeesData: [],
      arrMappedAttndees: [],
      GlobalKeysData: {
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
      },
    };
  },
  computed: {
    getEventID() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventid;
    },
    finalRoundTables() {
      let roundtables = [];
      if (self.SessionRTGroupIDsLoaded && self.expoTableIDsLoaded) {
        self.roundtableData.forEach(function (item) {
          if (
            !self.SessionRTGroupIDs.includes(item.Topic.TopicId) &&
            !self.expoTableIDs.includes(item.TableId)
          )
            roundtables.push(item);
        });
      }
      return roundtables;
    },
  },
  async mounted() {
    self = this;
    if (screen.width >= 768 && screen.width <= 1024) {
      common.checkAppDownloadScreenByDevice("ipad");
    } else if (screen.width < 767) {
      common.checkAppDownloadScreenByDevice("mobile");
    }
    /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------Page Title-------------

    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();

        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            debugger;
            if (value.Name == "RoundTables") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else {
                self.headerText = value.DisplayLabel;
              }
              if (self.headerText === undefined) {
                self.headerText = value.DisplayLabel;
              }
              document.title = self.headerText + " - " + obj.eventname;
              document.getElementById("headerLabel").innerText =
                self.headerText;
            }
          }
        });
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "RoundTables") {
              self.headerText = value.DisplayLabel;
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else {
                self.headerText = value.DisplayLabel;
              }
              if (self.headerText === undefined) {
                self.headerText = value.DisplayLabel;
              }
              document.title = self.headerText + " - " + obj.eventname;
              document.getElementById("headerLabel").innerText =
                self.headerText;
            }
          }
        });
      });

    //---------------------------------------------------
    //-------------------------------------------------------------------------------

    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black";
          }
        } else {
          self.textColor = "black";
        }
        console.log("BodyTextColor :- " + self.textColor);
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }
    $("#btnAddUserView").click();
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    $("#topmenu").show();
    $("#leftmenu").show();
    self.scroll();
    self.roundtableIds = [];
    self.roundtableData = [];
    self.setFirebaseAppsettings();
    self.displayRoundtable();
    obj = JSON.parse(window.localStorage.getItem("my-app"));

    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );
    self.clientid = obj.client[0].id;
    self.eventId2 = obj.eventid;
    self.userid = obj.user[0].id;
    self.eventcollectionname = obj.eventcollectionname;
    self.tid =
      this.$route.params.tid == undefined ? "" : this.$route.params.tid;
    self.timerLoader = 0;
    if (self.tid == "") {
      self.tid = "All";
    }
    self.selectedTopic = self.tid;
    //--------get  setting---------------------------------------------------------------------------------

    self.ShowFilter = false;
    self.ShowSearch = false;
    var refTableSettings = db
      .collection(obj.eventcollectionname)
      .doc("Settings")
      .collection("Roundtable")
      .doc("RoundtableSettings");
    refTableSettings.get().then(function (doc) {
      if (doc.exists) {
        self.ShowFilter =
          doc.data().ShowFilter == undefined ? false : doc.data().ShowFilter;
        self.ShowSearch =
          doc.data().ShowSearch == undefined ? false : doc.data().ShowSearch;
        if (doc.data().HostLegend != undefined) {
          self.roundtableSettings.HostLegend = doc.data().HostLegend;
        }
        if (self.roundtableSettings.HostLegend == "") {
          self.roundtableSettings.HostLegend = self.$t("livestage.host");
        }
        if (doc.data().SeatGrabText != undefined) {
          self.roundtableSettings.SeatGrabText = doc.data().SeatGrabText;
        }

        if (doc.data().AllowAudienceViewText != undefined) {
          self.roundtableSettings.AllowAudienceViewText =
            doc.data().AllowAudienceViewText;
        }
        if (doc.data().TableFullText != undefined) {
          self.roundtableSettings.TableFullText = doc.data().TableFullText;
        }
      }
    });
    //-----------GEt filter data------------------------------------------------------------------------------
  },
  methods: {
    GoForInternalPlayer(roundtableID, StreamingClient, Zoom_Detail, hostId) {
      debugger;
      if (StreamingClient.toLowerCase() == "zoom") {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var attendeeId = obj.user[0].id;
        var first_name = obj.user[0].fname;
        var last_name = obj.user[0].lname;

        if (Zoom_Detail && Zoom_Detail.id) {
          if (attendeeId == hostId) {
            var hlink =
              Zoom_Detail.start_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(hlink, "_blank");
          } else {
            var link =
              Zoom_Detail.join_url +
              "&uname=" +
              first_name.trim() +
              "%20" +
              last_name.trim();
            window.open(link, "_blank");
          }
        } else {
          alert(self.zoomErrorMsg);
          self.hideLoader();
        }
      } else {
        //var obj2 = JSON.parse(window.localStorage.getItem("my-app"));
        // if (
        //   screen.width < 767 &&
        //   obj2.AgoraPlayerBrowserSupportInMobile == false
        // ) {
        //   router.push("/screeninfo");
        // } else if (
        //   screen.width >= 768 &&
        //   screen.width <= 1024 &&
        //   obj2.AgoraPlayerBrowserSupportInIPad == false
        // ) {
        //   router.push("/screeninfo");
        // } else {
          router.push({
            path: "/livestage/" + roundtableID + "_rt",
          });
        // }
      }
    },
    //ROUND TABLE START
    /*LoadRoundTableSettings() {
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Roundtable")
        .doc("RoundtableSettings")
        .onSnapshot(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            if (typeof data.ShowSpeakerList != undefined) {
              self.roundtableSettings.isSpeakerTabVisible =
                data.ShowSpeakerList;
            }
            if (typeof data.ShowAttendeeList != undefined) {
              self.roundtableSettings.isAttendeeTabVisible =
                data.ShowAttendeeList;
            }
            if (typeof data.EnableGroupChat != undefined) {
              self.roundtableSettings.isChatTabVisible = data.EnableGroupChat;
            }
            if (typeof data.EnableRaiseHand != undefined) {
              self.roundtableSettings.isRaiseHandTabVisible =
                data.EnableRaiseHand;
            }

            if (typeof data.SeatGrabText != undefined) {
              self.roundtableSettings.SeatGrabText = data.SeatGrabText;
            }

            if (typeof data.ShowFilter != undefined) {
              self.roundtableSettings.ShowFilter = data.ShowFilter;
            }
            if (typeof data.ShowSearch != undefined) {
              self.roundtableSettings.ShowSearch = data.ShowSearch;
            }
            if (typeof data.AllowScreenShare != undefined) {
              self.roundtableSettings.AllowScreenShare = data.AllowScreenShare;
            }
            if (typeof data.AllowRecording != undefined) {
              self.roundtableSettings.AllowRecording = data.AllowRecording;
            }
          }
        });
    },*/
    searchRoundtable2: function () {
      if (self.searchtext == "") {
        //  $("#dvRoundtable").html("");
        // self.totalRecords = 1;
        // self.firstPageCalled = false;
        // self.pageIndex = 0;
        // self.hasMore = true;
        //lastVisible = null;
        self.roundtableData = [];

        self.displayRoundtable();
      }
    },
    searchRoundtable: function () {
      //
      // alert("Enter was pressed");
      // if (e.keyCode === 13) {
      //   alert("Enter was pressed");
      //   return false;
      // }
      //   $("#dvRoundtable").html("");

      /*self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.hasMore = true;
      self.lastVisible = null;
      self.attendeeData = [];
      setTimeout(function () {
        self.displayAttendees();
      }, 1000);*/
      // self.totalRecords = 1;
      // self.firstPageCalled = false;
      // self.pageIndex = 0;
      // self.hasMore = true;
      // lastVisible = null;
      self.roundtableData = [];
      self.displayRoundtable();
    },
    displayRoundtable() {
      //  debugger;
      //alert();
      self.roundtableTopicData = [];
      self.roundtableTopicData.push({
        id: "All",
        TopicId: "All",
        TopicName: this.$t("filter.All"),
      });
      self.roundtableData = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log(obj.eventcollectionname);
      if (obj && obj.eventcollectionname) {
        db.collection(obj.eventcollectionname)
          .doc("SessionList")
          .collection("Sessions")
          .where("SessionTypeDetails.TypeID", "==", 4)
          .get()
          .then((querySnapshotSn) => {
            querySnapshotSn.forEach((docSn) => {
              let session = docSn.data();
              if (
                session.SessionTypeDetails.RoundTableTopic &&
                session.SessionTypeDetails.RoundTableTopic.TopicId
              ) {
                self.SessionRTGroupIDs.push(
                  session.SessionTypeDetails.RoundTableTopic.TopicId
                );
              }
            });
            if (self.searchtext.trim() != "") {
              db.collection(obj.eventcollectionname)
                .doc("RoundTableList")
                .collection("RoundTables")
                .where("IsPublished", "==", true)
                .get()
                .then((querySnapshot) => {
                  self.roundtableData = [];
                  querySnapshot.forEach((doc) => {
                    if (doc.data().TableId == "729000") {
                      //  debugger;
                    }
                    let flag = true;
                    if (
                      doc.data().Topic &&
                      doc.data().Topic.TopicId &&
                      self.SessionRTGroupIDs.includes(doc.data().Topic.TopicId)
                    ) {
                      flag = false;
                    } else if (
                      doc.data().MapTo &&
                      doc.data().MapTo.IsMapped &&
                      doc.data().MapTo.Entity &&
                      doc.data().MapTo.Entity.Id
                    ) {
                      flag = false;
                    }
                    if (flag) {
                      //--------------------------------
                      var isMappedasAttendee = false;
                      var isHost = false;
                      var hostId = "0";
                      var preassinedAtt = doc.data().MappedAttendees;
                      var preAssisgnedAtt = preassinedAtt.filter(function (
                        value
                      ) {
                        return value.AttendeeId == self.userid;
                      });
                      if (preAssisgnedAtt.length > 0) {
                        isMappedasAttendee = true;
                      }
                      var host = doc.data().Host;
                      if (host != undefined) {
                        if (host.length > 0) {
                          hostId =
                            host[0].AttendeeId == undefined
                              ? "0"
                              : host[0].AttendeeId;
                          if (
                            host[0].AttendeeId != undefined &&
                            host[0].AttendeeId == self.userid
                          ) {
                            isHost = true;
                          }
                        }
                      }

                      var tbObj = new Object();
                      tbObj.topicVisibility = false;
                      //alert("self.tid: " + self.tid);
                      if (self.tid == "" || self.tid.toLowerCase() == "all") {
                        tbObj.topicVisibility = true;
                      } else {
                        if (doc.data().Topic.TopicId == self.tid) {
                          tbObj.topicVisibility = true;
                        }
                      }
                      let topics = self.roundtableTopicData.filter(function (
                        item
                      ) {
                        return item.id == doc.data().Topic.TopicId;
                      });
                      if (topics.length == 0) {
                        self.roundtableTopicData.push({
                          id: doc.data().Topic.TopicId,
                          TopicId: doc.data().Topic.TopicId,
                          TopicName: doc.data().Topic.TopicName,
                        });
                      }
                      //---------------id and capacity array------------------------------------------
                      var tbObjIds = new Object();
                      tbObjIds.id = doc.id;

                      // if (doc.id == "961000") {
                      //   debugger;
                      // }
                      tbObjIds.Capacity = isNaN(doc.data().Capacity)
                        ? 12
                        : doc.data().Capacity;

                      self.roundtableIds.push(tbObjIds);
                      // self.roundtableIds.push(doc.id);
                      //------------------------------------------------------------------------------
                      tbObj.id = doc.id;
                      tbObj.hostId = hostId;
                      console.log(doc.id + "HostId:- " + hostId);
                      tbObj.Name = doc.data().TableName;
                      tbObj.Occupied = doc.data().Occupied;
                      //tbObj.Capacity = doc.data().Capacity;
                      tbObj.Capacity = 8;
                      if (doc.data().Capacity && !isNaN(doc.data().Capacity)) {
                        tbObj.Capacity = doc.data().Capacity;
                      }
                      if (tbObj.Capacity < 2) {
                        tbObj.Capacity = 2;
                      } else if (tbObj.Capacity > 16) {
                        tbObj.Capacity = 16;
                      }
                      tbObj.BroadcastID = self.GlobalKeysData.BroadcastID;
                      tbObj.BroadcastCertificat =
                        self.GlobalKeysData.BroadcastCertificate;
                      tbObj.BroadcastSpeakerApiUrl =
                        self.GlobalKeysData.BroadcastSpeakerApiUrl;
                      tbObj.BroadcastAttendeeApiUrl =
                        self.GlobalKeysData.BroadcastAttendeeApiUrl;
                      tbObj.BroadcastStartURL =
                        self.GlobalKeysData.BroadcastStartURL;
                      tbObj.BroadcastViewURL =
                        self.GlobalKeysData.BroadcastViewURL;
                      tbObj.BroadcastvalidityHours =
                        self.GlobalKeysData.BroadcastvalidityHours;
                      tbObj.ChannelPrefix = self.GlobalKeysData.ChannelPrefix;
                      tbObj.IsHost = isHost;
                      tbObj.IsMappedasAttendee = isMappedasAttendee;
                      tbObj.PreAssigned = doc.data().PreAssigned;
                      tbObj.SpectatorEnabled = doc.data().SpectatorEnabled;
                      tbObj.IsTableFull = false;
                      tbObj.IsVisible = false;
                      tbObj.IsTblVisible = false;
                      tbObj.StreamingClient = "";
                      tbObj.StreamingClientLink = "";
                      if (
                        doc.data().StreamingClient &&
                        doc.data().StreamingClient.trim() != ""
                      ) {
                        tbObj.StreamingClient = doc
                          .data()
                          .StreamingClient.trim();
                      }
                      if (
                        doc.data().StreamingClientLink &&
                        doc.data().StreamingClientLink.trim() != ""
                      ) {
                        tbObj.StreamingClientLink = doc
                          .data()
                          .StreamingClientLink.trim();
                      }
                      if (tbObj.StreamingClient.toLowerCase() == "zoom") {
                        tbObj.Capacity = 16;
                        tbObj.Zoom_Detail = doc.data().Zoom_Detail;
                      }
                      //let capacity = tbObj.Capacity.toString();
                      //if (capacity.length == 1) {
                      //  capacity = "0" + capacity;
                      //}
                      tbObj.imgsrc =
                        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                        tbObj.Capacity +
                        "%2F01.jpg?alt=media";

                      tbObj.tableLabel = self.roundtableSettings.SeatGrabText;
                      tbObj.LabelCss = "grab-a-seat";

                      if (
                        tbObj.Name.toLowerCase().includes(
                          self.searchtext.toLowerCase()
                        )
                      ) {
                        self.roundtableData.push(tbObj);
                      }
                    }
                  });
                  self.getTblTest();
                  setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                  }, 1000);
                }) //querySnapshot.forEach(doc =>  ENDING PART
                .catch((error) => {
                  alert(error);
                });
            } else {
              db.collection(obj.eventcollectionname)
                .doc("RoundTableList")
                .collection("RoundTables")
                .where("IsPublished", "==", true)
                .get()
                .then((querySnapshot) => {
                  self.roundtableData = [];
                  querySnapshot.forEach((doc) => {
                    if (doc.data().TableId == "729000") {
                      //  debugger;
                    }
                    let flag = true;
                    if (
                      doc.data().Topic &&
                      doc.data().Topic.TopicId &&
                      self.SessionRTGroupIDs.includes(doc.data().Topic.TopicId)
                    ) {
                      flag = false;
                    } else if (
                      doc.data().MapTo &&
                      doc.data().MapTo.IsMapped &&
                      doc.data().MapTo.Entity &&
                      doc.data().MapTo.Entity.Id
                    ) {
                      flag = false;
                    }
                    if (flag) {
                      var isMappedasAttendee = false;
                      var isHost = false;
                      var hostId = "0";
                      var preassinedAtt = doc.data().MappedAttendees;
                      var preAssisgnedAtt = preassinedAtt.filter(function (
                        value
                      ) {
                        return value.AttendeeId == self.userid;
                      });
                      if (preAssisgnedAtt.length > 0) {
                        isMappedasAttendee = true;
                      }
                      var host = doc.data().Host;
                      if (host != undefined) {
                        if (host.length > 0) {
                          hostId =
                            host[0].AttendeeId == undefined
                              ? "0"
                              : host[0].AttendeeId;
                          if (
                            host[0].AttendeeId != undefined &&
                            host[0].AttendeeId == self.userid
                          ) {
                            isHost = true;
                          }
                        }
                      }

                      var tbObj = new Object();
                      tbObj.topicVisibility = false;
                      if (self.tid == "" || self.tid.toLowerCase() == "all") {
                        //alert("self.tid: " + self.tid);
                        tbObj.topicVisibility = true;
                      } else {
                        if (doc.data().Topic.TopicId == self.tid) {
                          //alert("self.tid: " + self.tid);
                          tbObj.topicVisibility = true;
                        }
                      }

                      let topics = self.roundtableTopicData.filter(function (
                        item
                      ) {
                        return item.id == doc.data().Topic.TopicId;
                      });
                      if (topics.length == 0) {
                        self.roundtableTopicData.push({
                          id: doc.data().Topic.TopicId,
                          TopicId: doc.data().Topic.TopicId,
                          TopicName: doc.data().Topic.TopicName,
                        });
                      }
                      //var tbObj = new Object();
                      //debugger;
                      //var hostCollection = doc.data().Host;
                      //if (hostCollection[0] != undefined) {
                      //  //if (hostCollection.lenght > 0) {
                      //  hostId =
                      //    hostCollection[0].AttendeeId == undefined
                      //      ? "0"
                      //      : hostCollection[0].AttendeeId;
                      //  // }
                      //}

                      //---------------id and capacity array------------------------------------------
                      var tbObjIds = new Object();
                      tbObjIds.id = doc.id;

                      // if (doc.id == "961000") {
                      //   debugger;
                      // }
                      tbObjIds.Capacity = isNaN(doc.data().Capacity)
                        ? 12
                        : doc.data().Capacity;

                      self.roundtableIds.push(tbObjIds);
                      // self.roundtableIds.push(doc.id);
                      //------------------------------------------------------------------------------
                      tbObj.id = doc.id;
                      tbObj.hostId = hostId;
                      console.log(doc.id + "HostId:- " + hostId);
                      tbObj.Name = doc.data().TableName;
                      tbObj.Occupied = doc.data().Occupied;
                      //tbObj.Capacity = doc.data().Capacity;
                      tbObj.Capacity = 8;
                      if (doc.data().Capacity && !isNaN(doc.data().Capacity)) {
                        tbObj.Capacity = doc.data().Capacity;
                      }
                      if (tbObj.Capacity < 2) {
                        tbObj.Capacity = 2;
                      } else if (tbObj.Capacity > 16) {
                        tbObj.Capacity = 16;
                      }
                      tbObj.BroadcastID = self.GlobalKeysData.BroadcastID; // "605f401455444442838e00cb859c037b";
                      tbObj.BroadcastCertificat =
                        self.GlobalKeysData.BroadcastCertificate; // "8f472eef21f64cba97c105eab797522f";
                      tbObj.BroadcastSpeakerApiUrl =
                        self.GlobalKeysData.BroadcastSpeakerApiUrl; //"https://onairapi.e2m.live/get-session-token-speaker";
                      tbObj.BroadcastAttendeeApiUrl =
                        self.GlobalKeysData.BroadcastAttendeeApiUrl; //"https://onairapi.e2m.live/get-session-token-attendee";
                      tbObj.BroadcastStartURL =
                        self.GlobalKeysData.BroadcastStartURL; //"https://onair2.e2m.live/video/live-broadcast.html";
                      tbObj.BroadcastViewURL =
                        self.GlobalKeysData.BroadcastViewURL; //"https://onair2.e2m.live/video/live-audience.html";
                      tbObj.BroadcastvalidityHours =
                        self.GlobalKeysData.BroadcastvalidityHours; //"72";
                      tbObj.ChannelPrefix = self.GlobalKeysData.ChannelPrefix; //"OAUAT";
                      tbObj.IsHost = isHost;
                      tbObj.IsMappedasAttendee = isMappedasAttendee;
                      tbObj.PreAssigned = doc.data().PreAssigned;
                      tbObj.SpectatorEnabled = doc.data().SpectatorEnabled;
                      tbObj.IsTableFull = false;
                      tbObj.IsVisible = false;
                      tbObj.IsTblVisible = false;
                      tbObj.StreamingClient = "";
                      tbObj.StreamingClientLink = "";
                      if (
                        doc.data().StreamingClient &&
                        doc.data().StreamingClient.trim() != ""
                      ) {
                        tbObj.StreamingClient = doc
                          .data()
                          .StreamingClient.trim();
                      }
                      if (
                        doc.data().StreamingClientLink &&
                        doc.data().StreamingClientLink.trim() != ""
                      ) {
                        tbObj.StreamingClientLink = doc
                          .data()
                          .StreamingClientLink.trim();
                      }
                      if (tbObj.StreamingClient.toLowerCase() == "zoom") {
                        tbObj.Capacity = 16;
                        tbObj.Zoom_Detail = doc.data().Zoom_Detail;
                      }
                      //let capacity = tbObj.Capacity.toString();
                      //if (capacity.length == 1) {
                      //  capacity = "0" + capacity;
                      //}

                      tbObj.imgsrc =
                        "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                        tbObj.Capacity +
                        "%2F01.jpg?alt=media";

                      tbObj.tableLabel = self.roundtableSettings.SeatGrabText;
                      tbObj.LabelCss = "grab-a-seat";

                      self.roundtableData.push(tbObj);
                    }
                  });
                  self.getTblTest();
                  setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                  }, 1000);
                }) //querySnapshot.forEach(doc =>  ENDING PART
                .catch((error) => {
                  alert(error);
                });
            }
          });
      }
    },
    setFirebaseAppsettings: function () {
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");

      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    getTblTest: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      for (var j = 0; j < self.roundtableData.length; j++) {
        if (self.roundtableData[j].StreamingClient.toLowerCase() == "zoom") {
          self.roundtableData[j].IsTblVisible =
            self.roundtableData[j].topicVisibility;
          self.roundtableData[j].IsVisible = true;
        } else {
          var col_name =
            "/" +
            obj.eventcollectionname +
            "/RoundTableList/RoundTables/" +
            self.roundtableData[j].id +
            "/Participances";
          // console.log(col_name);
          console.log(col_name);
          db.collection(col_name)
            // .where("IsActive", "==", true)
            .onSnapshot((querySnapshot) => {
              // console.log("listner callded");
              //var capa = 12;
              debugger;
              //if (querySnapshot.docs.length > 0) {
              //  var ftid = querySnapshot.docs[0].data().TableId;
              //  var tblList = self.roundtableIds.filter(function (item) {
              //    // alert(item.id);
              //    // alert(ftid);
              //    return item.id == ftid;
              //  });
              //  debugger;
              //  //if (tblList.length > 0) {
              //  //  capa = tblList[0].Capacity;
              //  //}
              //}
              var members = [];
              var curtbId;
              let iAmInTheTable = false;
              querySnapshot.forEach((doc) => {
                var participant = doc.data();
                // console.log(curDoc);
                curtbId = participant.TableId;
                let attType = 1;
                if (
                  participant.AttendeeType != undefined &&
                  participant.AttendeeType != null
                ) {
                  attType = participant.AttendeeType;
                }
                if (participant.IsActive && attType > 0 && attType < 4) {
                  if (participant.AttendeeId == self.userid) {
                    iAmInTheTable = true;
                  }
                  members.push(participant);
                }
                //if (curDoc.IsActive) {
                //  members.push(curDoc);
                //}
              });
              debugger;
              //  console.log("indx:- " + (j - 1));
              // console.log("capa:- " + capa);
              self.updateSinglTable(curtbId, members, iAmInTheTable);
              //console.log(members);
            });
        }
      }
      //console.log(self.roundtableIds);
    },
    updateSinglTable: function (curtbId, members, iAmInTheTable) {
      // var cnt = members.length;
      // console.log(cnt);
      var img = "";
      for (var i = 0; i < self.roundtableData.length; i++) {
        if (self.roundtableData[i].id == curtbId) {
          //if (curtbId == "2028000") {
          //  alert(iAmInTheTable);
          //}
          let table = self.roundtableData[i];
          var filteredIds = members.filter(function (value) {
            return value.AttendeeId != table.hostId && value.IsActive == true;
          });
          let Capacity = table.Capacity;
          //------------------------------------------------------------------------------------------------------------------------------------------------
          var cnt = filteredIds.length + 1;

          /*============================================================================================================================================== */
          // Capacity = 5;
          if (curtbId == "526000") {
            //     debugger;
            console.log("count:- " + cnt);
          }
          if (cnt < 1) {
            cnt = 1;
          } else if (cnt > Capacity) {
            cnt = Capacity;
          }

          if (filteredIds.length == members.length) {
            //host inactive
            if (cnt == undefined || cnt <= 0) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 1) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 2) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 3) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 4) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 5) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 6) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 7) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 8) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 9) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 10) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 11) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F11.jpg?alt=media&token=802d8c4a-0c26-4493-a111-dc95d659b6a5";
            } else if (cnt == 12) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F12.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 13) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F13.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 14) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F14.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt == 15) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F15.jpg?alt=media&token=afa22cdd-6448-4233-a2ae-7c0ecb38e9fd";
            } else if (cnt >= 16) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FinactiveHost%2F" +
                Capacity +
                "%2F16.jpg?alt=media";
            }
          } else {
            //host active
            if (cnt == undefined || cnt <= 0) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 1) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F01.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 2) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F02.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 3) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F03.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 4) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F04.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 5) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F05.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 6) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F06.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 7) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F07.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 8) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F08.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 9) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F09.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 10) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F10.jpg?alt=media&token=8301efc4-7b76-4409-9c8e-723002b62e49";
            } else if (cnt == 11) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F11.jpg?alt=media&token=1d49ccca-4d81-4d53-bf95-b635598bc0a8";
            } else if (cnt == 12) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F12.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 13) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F13.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 14) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F14.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt == 15) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F15.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            } else if (cnt >= 16) {
              img =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2FactiveHost%2F" +
                Capacity +
                "%2F16.jpg?alt=media&token=05959b19-a5b5-4c98-ad53-8e2543db4a23";
            }
          }

          /*=============================================================================================================================================== */

          /*if (cnt == undefined || cnt <= 0) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F00.jpg?alt=media";
            } else if (cnt == 1) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F01.jpg?alt=media";
            } else if (cnt == 2) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F02.jpg?alt=media";
            } else if (cnt == 3) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F03.jpg?alt=media";
            } else if (cnt == 4) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F04.jpg?alt=media";
            } else if (cnt == 5) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F05.jpg?alt=media";
            } else if (cnt >= 6) {
              img =
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F06.jpg?alt=media";
            }else {
            img =
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FRoundTable%2F06.jpg?alt=media";
          }*/
          /*====================================================================================================== */
          if (table.id == "729000") {
            //  debugger;
          }
          var tableLabel = self.roundtableSettings.SeatGrabText; // "GRAB A SEAT";//dynamic settings
          var LabelCss = "grab-a-seat";
          var showTable = false;
          var IsTableFull = false;
          if (table.IsHost) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.PreAssigned) {
            if (table.IsMappedasAttendee) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Speaker
              showTable = true;
            } else if (table.SpectatorEnabled) {
              //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
              //Join As Audience
              showTable = true;
              tableLabel = self.roundtableSettings.AllowAudienceViewText; // "SPECTATE";//dynamic settings
              LabelCss = "spectate";
            }
          } else if (iAmInTheTable) {
            showTable = true;
          } else if (cnt < table.Capacity) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Speaker
            showTable = true;
          } else if (table.SpectatorEnabled) {
            //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
            //Join As Audience
            showTable = true;
            tableLabel = self.roundtableSettings.AllowAudienceViewText; //"SPECTATE";//dynamic settings
            LabelCss = "spectate";
            //alert("spectate");
          } else {
            showTable = true;
            IsTableFull = true;
            tableLabel = self.roundtableSettings.TableFullText; //"TABLE FULL";//dynamic settings
            LabelCss = "table-full";
          }

          /*========================================================================================================== */
          table.IsTableFull = IsTableFull;
          table.IsVisible = showTable;
          table.IsTblVisible = showTable && table.topicVisibility;
          //table.IsTblVisible = table.topicVisibility;
          table.tableLabel = tableLabel;
          table.imgsrc = img;
          table.LabelCss = LabelCss;
          console.log(img);
          break;
        }
      }
    },

    onChange(event) {
      // alert(event.target.value);
      self.tid = event.target.value;
      if (self.tid != "") {
        if (self.tid != "All") {
          router.push("/roundtable/" + self.tid);
        } else {
          router.push("/roundtable");
        }
      } else {
        router.push("/roundtable");
      }

      //alert(self.tid);
      self.displayRoundtable();
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    JoinTable: function (
      hostId,
      videoParamsEncryptURL,
      IsBroadcastInNewTab,
      tableId,
      tableName,
      leaveTable,
      ChannelPrefix,
      BroadcastID,
      BroadcastCertificate,
      BroadcastSpeakerApiUrl,
      BroadcastAttendeeApiUrl,
      BroadcastvalidityHours,
      UserID,
      eventID,
      BroadcastStartURL,
      BroadcastViewURL,
      IsHost,
      IsMappedasAttendee,
      PreAssigned,
      SpectatorEnabled,
      Capacity,
      Occupied,
      IsVisible,
      IsTableFull,
      IsOpenInternalPlayer,
      StreamingClient,
      Zoom_Detail
    ) {
      $(".tooltip").tooltip("hide");
      //alert("1");
      if (IsVisible && !IsTableFull) {
        if (IsOpenInternalPlayer == 1) {
          self.GoForInternalPlayer(
            tableId,
            StreamingClient,
            Zoom_Detail,
            hostId
          );
        } else {
          //var obj1 = JSON.parse(window.localStorage.getItem("my-app"));
          // if (
          //   screen.width < 767 &&
          //   obj1.AgoraPlayerBrowserSupportInMobile == false
          // ) {
          //   router.push("/screeninfo");
          // } else if (
          //   screen.width >= 768 &&
          //   screen.width <= 1024 &&
          //   obj1.AgoraPlayerBrowserSupportInIPad == false
          // ) {
          //   router.push("/screeninfo");
          // } else {
            var OnAirVCount = this.readCookieForVideo("onairvcount");
            var videoLaunchFlag = true;
            if (OnAirVCount != null) {
              if (parseInt(OnAirVCount) >= 1) {
                if (
                  !confirm(
                    "An active OnAir video seems to be running, it is recommended to open one video at a time for best performance. Do you still want to open the video in another tab?"
                  )
                ) {
                  videoLaunchFlag = false;
                }
              }
            }
            if (videoLaunchFlag) {
              //alert(videoParamsEncryptURL);
              if (tableId == undefined || tableId == "" || tableId == 0) {
                //  alert("Invalid table selected");
                return;
              }
              // debugger;
              var obj = JSON.parse(window.localStorage.getItem("my-app"));
              var clntid = obj.client[0].id;
              // self.clientid = obj.user[0].id;
              var evntid = obj.eventid;
              var usrid = obj.user[0].id;
              //alert("usrid" + usrid);
              // alert("clntid" + clntid);
              console.log("JoinTable- usrid : -" + usrid);
              console.log(Occupied);
              // console.log("MappedAttendees : - " + MappedAttendees);

              // console.log("SpectatorEnabled: - " + SpectatorEnabled);

              //var userName = obj.user[0].name;
              // var userImage = obj.user[0].profilepic;
              // var userEmail = obj.user[0].Email;
              // var userPhone = obj.user[0].Phone;
              //var userTitle = obj.user[0].title;
              var OpenBroadcastWindow = 0;
              // var isSpectate = 1; //audience mode
              var openAsSpeaker = false;
              var openAsAudience = false;
              var participantOccupied = 0;

              db.collection(self.eventcollectionname)
                .doc("RoundTableList")
                .collection("RoundTables")
                .doc(tableId)
                .collection("Participances")
                //.where("IsActive", "==", true)
                .get()
                .then((querySnapshot) => {
                  // debugger;
                  var filteredIds = querySnapshot.docs.filter(function (value) {
                    return (
                      value.data().AttendeeId != hostId &&
                      value.data().IsActive == true
                    );
                  });

                  participantOccupied = filteredIds.length + 1;

                  // alert("PreAssigned : - " + PreAssigned);
                  //alert("participantOccupied : - " + participantOccupied);
                  if (IsHost) {
                    //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
                    //Join As Speaker
                    // isSpectate = 0;
                    openAsSpeaker = true;
                  } else if (PreAssigned) {
                    if (IsMappedasAttendee) {
                      //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
                      //Join As Speaker
                      //isSpectate = 0;
                      openAsSpeaker = true;
                    } else if (SpectatorEnabled) {
                      //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
                      //Join As Audience
                      // isSpectate = 1;
                      openAsAudience = true;
                    }
                  } else if (participantOccupied < Capacity) {
                    //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
                    //Join As Speaker
                    // isSpectate = 0;
                    openAsSpeaker = true;
                  } else if (SpectatorEnabled) {
                    //Show Table In Table List Page (Need ti discuss show/hide or disable like think)
                    //Join As Audience
                    //isSpectate = 1;
                    openAsAudience = true;
                  }

                  OpenBroadcastWindow = 1;

                  if (OpenBroadcastWindow == 1) {
                    var channelid2 =
                      ChannelPrefix +
                      "_" +
                      evntid.substring("1") +
                      "_" +
                      tableId.toString().toLowerCase().replace("rt", "") +
                      "_rt";
                    // alert(channelid2);
                    console.log(channelid2);

                    // alert(videoURL);
                    var broadcastTypeUrl = "";
                    /* if (isSpectate == 1) {
            broadcastTypeUrl = BroadcastViewURL;
          } else {
            broadcastTypeUrl = BroadcastStartURL;
          }*/

                    if (openAsAudience == true) {
                      broadcastTypeUrl = BroadcastViewURL;
                    }
                    if (openAsSpeaker == true) {
                      broadcastTypeUrl = BroadcastStartURL;
                    }
                    //alert("broadcastTypeUrl" + broadcastTypeUrl);
                    //alert("videoParamsEncryptURL" + videoParamsEncryptURL);
                    /* alert(
          "Parameters - url - " +
            videoParamsEncryptURL +
            "broadcastTypeUrl- " +
            broadcastTypeUrl +
            "BroadcastvalidityHours - " +
            BroadcastvalidityHours +
            "channelid2 - " +
            channelid2 +
            "usrid - " +
            usrid +
            "tableName - " +
            tableName +
            "clntid - " +
            clntid
        );*/
                    console.log(
                      "Parameters - url - " +
                        videoParamsEncryptURL +
                        "broadcastTypeUrl- " +
                        broadcastTypeUrl +
                        "BroadcastvalidityHours - " +
                        BroadcastvalidityHours +
                        "channelid2 - " +
                        channelid2 +
                        "usrid - " +
                        usrid +
                        "tableName - " +
                        tableName +
                        " clntid - " +
                        clntid
                    );

                    this.getEncryptedVideoURLParams(
                      videoParamsEncryptURL,
                      broadcastTypeUrl,
                      BroadcastvalidityHours,
                      channelid2,
                      usrid,
                      tableName,
                      clntid,
                      function (videoURL, usrid) {
                        // alert(videoURL);
                        console.log(usrid);

                        if (IsBroadcastInNewTab) {
                          //window.parent.location.reload();
                          window.open(videoURL, "_blank");
                        } else {
                          $("#iframeBroadcast").attr(
                            "src",
                            videoURL + "&t=" + new Date().getTime()
                          );
                          $("#modalOpenBroadcast").modal();
                        }
                      }
                    );
                  } else {
                    //alert("You are not allowed to join this table");
                  }
                });
            }
          // }
        }
      }
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
    },
    toggleModal: function () {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    getTopicList() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // console.log("EventColName : " + obj.eventcollectionname);
      if (obj && obj.eventcollectionname) {
        db.collection(obj.eventcollectionname)
          .doc("SessionList")
          .collection("Sessions")
          .where("SessionTypeDetails.TypeID", "==", 4)
          .get()
          .then((querySnapshotSn) => {
            let sessionRTTopicIDs = [];
            querySnapshotSn.forEach((docSn) => {
              let session = docSn.data();
              if (
                session.SessionTypeDetails.RoundTableTopic &&
                session.SessionTypeDetails.RoundTableTopic.TopicId
              ) {
                sessionRTTopicIDs.push(
                  session.SessionTypeDetails.RoundTableTopic.TopicId
                );
              }
            });
            db.collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
              .doc("RoundTableTopicList")
              .collection("RoundTableTopics")
              .get()
              .then((querySnapshot) => {
                self.roundtableTopicData = [];
                // debugger;
                self.roundtableTopicData.push({
                  id: "All",
                  TopicId: "All",
                  TopicName: this.$t("filter.All"),
                });
                querySnapshot.forEach((doc) => {
                  if (!sessionRTTopicIDs.includes(doc.data().TopicId)) {
                    self.roundtableTopicData.push({
                      id: doc.id,
                      TopicId: doc.data().TopicId,
                      TopicName: doc.data().TopicName,
                    });
                  }
                });

                // console.log(this.roundtableTopicData);
              });
          });
      }
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },

    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    scroll: function () {
      window.onscroll = () => {
        //alert("scroll");
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
  },
};
</script>
